import { render, staticRenderFns } from "./EmployeeIndividualAwayAssignmentPage.vue?vue&type=template&id=10da4b4a&scoped=true&"
import script from "./EmployeeIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./EmployeeIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da4b4a",
  null
  
)

export default component.exports